import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import plural from 'pluralize';
import Spinner from '~/components/spinner/spinner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';

export const getProductsQuery = gql`
  query products($breweryId: Int!) {
    products(breweryId: $breweryId) {
      id
      lotPrefix
      name
      description
      costPerLitre
      abv
      currentlyBrewingVolume
      variants {
        id
      }
    }
  }
`;

const ProductsList = ({ brewery, history }) => (
  <Query query={getProductsQuery} variables={{ breweryId: brewery.id }}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      return (
        <Fragment>
          <URLParamBanner name="transfer schedule" />
          <Card className="content">
            <table className="table mb0">
              <thead>
                <tr>
                  <td />
                  <th className="bt-n bb-n">Name</th>
                  <th className="bt-n bb-n">Description</th>
                  <th className="bt-n bb-n">ABV</th>
                  <th className="bt-n bb-n">Currently Brewing</th>
                </tr>
              </thead>
              <tbody>
                {data.products.map(product => {
                  return (
                    <tr
                      className="table-row pointer"
                      key={product.id}
                      onClick={() => {
                        history.push(`/products/${product.id}`);
                      }}
                    >
                      <td>
                        <div className="pl3">
                          <strong>{product.lotPrefix}</strong>
                          <br />
                          <em>${product.costPerLitre}</em>
                        </div>
                      </td>
                      <td>
                        <strong>{product.name}</strong>
                        <br />
                        <em>
                          {product.variants.length} {plural('variation', product.variants.length)}
                        </em>
                      </td>
                      <td className="mw6">{product.description}</td>
                      <td>{product.abv}%</td>
                      <td>{product.currentlyBrewingVolume}L</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card>
        </Fragment>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(ProductsList));



// WEBPACK FOOTER //
// ./src/containers/productsList/productsList.jsx